import React, { useRef } from 'react'
import { Route, Redirect, Switch, useRouteMatch, useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import IdleTimer from 'react-idle-timer'
import PageNotFound from 'shared/components/PageNotFound.jsx'
import PrivateRoute from './PrivateRoute'
import PrivacyNotice from '../PrivacyNotice/index'
import ScreeningQuestion from '../ScreeningQuestion/index'
import ScreeningQuestionYes from '../ScreeningQuestionYes/index'
import FineInformation from '../FineInformation/index'
import FinePaymentInformation from '../FinePaymentInformation/index'
import FinesList from '../FinesList/index'
import ContactInformation from '../ContactInformation/index'
import ReviewConfirmation from '../ReviewConfirmation/index'
import ReceiveConfirmation from '../ReceiveConfirmation/index'
import Confirmation from '../Confirmation/index'
import Layout from 'containers/Layout/topbar/index.jsx'
import Footer from 'containers/Layout/footer/footer.jsx'

const PayFineRoutes = ({ t, i18n }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const idleMinutes = process.env.REACT_APP_IDLE_TIMEOUNT_MINUTES

  const idleEl = useRef(null)

  const onIdle = () => {
    //history.push(`${match.path}${t('routes.privacy_notice')}`)
    history.push(`${match.path}${t('routes.screening_question')}`)
  }

  return (
    <React.Fragment>
      <IdleTimer ref={idleEl} element={document} onIdle={onIdle} debounce={250} timeout={1000 * 60 * parseFloat(idleMinutes)} />
      <Layout />
      <Switch>
        <Route path={`${match.path}${t('routes.not_found')}`} component={PageNotFound} />
        <PrivateRoute path={`${match.path}${t('routes.receive_confirmation')}/:transId/:transOwner`} component={ReceiveConfirmation} />
        <Route path={`${match.path}${t('routes.confirmation')}`} component={Confirmation} />
        <PrivateRoute path={`${match.path}${t('routes.review_confirmation')}`} component={ReviewConfirmation} />
        <PrivateRoute path={`${match.path}${t('routes.contact_info')}`} component={ContactInformation} />
        <PrivateRoute path={`${match.path}${t('routes.listed_fines')}`} component={FinesList} />
        <PrivateRoute path={`${match.path}${t('routes.fine_owing_info')}`} component={FinePaymentInformation} />
        <PrivateRoute path={`${match.path}${t('routes.fine_info')}`} component={FineInformation} />
        <PrivateRoute path={`${match.path}${t('routes.screening_question_yes')}`} component={ScreeningQuestionYes} />
        <Route path={`${match.path}${t('routes.screening_question')}`} component={ScreeningQuestion} />
        {/* <Route path={`${match.path}${t('routes.privacy_notice')}`} component={PrivacyNotice} /> */}
        <Redirect from={`/${i18n.language}/*`} to={`${match.path}${t('routes.not_found')}`} />
        {/* <Redirect exact from={`${match.path}`} to={`${match.path}${t('routes.privacy_notice')}`} /> */}
        <Redirect exact from={`${match.path}`} to={`${match.path}${t('routes.screening_question')}`} />
      </Switch>
      <Footer />
    </React.Fragment>
  )
}

export default withTranslation('common')(PayFineRoutes)
